import styled, { css } from 'styled-components'
import Dropdown from '../../ui/Dropdown/Dropdown'
import LinkButton from '../../ui/LinkButton/LinkButton'
import media from '../../../services/generateMediaQueries'

export const MapView = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
export const MapViewWrapper = styled.div`
  position: relative;
  height: ${({ height }) => height || '100%'};
  width: ${({ width }) => width || '100%'};
`
export const TransparentLayer = styled.div`
  z-index: 4;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`
export const FloorControlArrow = styled.a`
  cursor: pointer;
  color: var(--color-primary);
  padding: 20px 10px;
  height: 56px;
  border-radius: 5px 0 0 5px;
  z-index: 2;

  &:hover {
    background-color: var(--color-primary);
    color: #fff;
  }

  ${media.lessThan('small')`
    padding: 0.5rem;
    height: unset;
  `}
`
export const FloorControlLabel = styled.span`
  padding: 20px 40px 20px 20px;
  z-index: 2;
  color: var(--color-primary);

  ${media.lessThan('small')`
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
  `}
`
export const FloorControlSelect = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  top: 24px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;

  ${media.greaterThan('small')`
    top: 96px;
  `}

  ${media.greaterThan('medium')`
    top: 24px;
  `}
`
export const FloorControlOption = styled.a`
  cursor: ${({ selected }) => (selected ? 'auto' : 'pointer')};
  display: block;
  padding: 20px 40px 20px 20px;
  color: ${({ selected }) => (selected ? '#fff' : 'currentColor')};
  background-color: ${({ selected }) =>
    selected ? 'var(--color-primary-hover)' : '#fff'};
  border-bottom: 1px solid var(--color-fg-lighter);
  &:last-child {
    border-bottom: 0;
    border-radius: 0 0 0 5px;
  }
  ${({ selected }) => (selected ? '&:hover { color: #fff; }' : '')};
`
export const FloorShortName = styled.span`
  padding-right: 10px;
  font-weight: var(--font-weight-bold);
`
export const FloorControlsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 16px;
  line-height: 16px;
`
export const FloorControls = styled.div`
  position: relative;
  display: flex;
  top: 24px;
  max-height: 56px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px 0 0 5px;
  background-color: #fff;

  ${media.greaterThan('small')`
    top: 96px;
  `}

  ${media.greaterThan('medium')`
    top: 24px;
  `}
`
export const ViewControlWrapper = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;

  ${media.lessThan('small')`
    display: none;
  `}
`
export const CompassWrapper = styled.div`
  position: relative;
  height: 50px;
  width: 50px;
  margin-bottom: 10px;
`
export const CompassContainer = styled.div`
  position: absolute;
  padding: 7px;
  transform: rotate(${({ rotation }) => rotation}rad);
`
export const Compass = styled.div`
  width: 36px;
  height: 36px;
  background-color: #fff;
  border-radius: 25px 25px 25px 0;
  transform: rotate(135deg);
  filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.4));
`
export const CompassLabel = styled.a`
  cursor: pointer;
  position: absolute;
  text-align: center;
  width: 50px;
  padding: 16px;
  font-size: 18px;
  font-weight: var(--font-weight-bold);
  line-height: 18px;
`
export const ZoomControlWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
`
export const ZoomControlItem = styled.a`
  cursor: pointer;
  color: var(--color-primary);
  padding: 10px;
  line-height: 29px;
  font-size: 20px;
  border-bottom: 1px solid var(--color-fg-lighter);
  text-align: center;

  &:last-child {
    border: none;
  }
`
export const SearchControlWrapper = styled.div`
  position: absolute;
  top: 24px;
  left: 24px;

  ${media.lessThan('small')`
    top: unset;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
  `}
`
export const SearchControlContainer = styled.div`
  border-radius: 5px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
  width: 450px;

  ${media.lessThan('small')`
    border-radius: 0;
    width: 100%;
  `}
`
export const SearchMain = styled.div`
  display: flex;

  ${media.lessThan('small')`
    display: block;
    padding: 1rem;
    background-color: #ffffff;

  `}
`
export const SearchField = styled.input.attrs({
  type: 'text',
  placeholder: 'Search',
})`
  background: #ffffff;
  font-weight: var(--font-weight);
  border: 0;
  padding: 0 20px;
  flex-grow: 1;

  ${media.lessThan('small')`
    height: 48px;
    width: 100%;
    border-radius: var(--border-radius-form);
    border: 1px solid var(--color-primary);
    display: block;
  `}
`
export const SearchResult = styled.div`
  position: absolute;
  top: 49px;
  width: 100%;
  max-height: 500px;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
  border-radius: 0 0 5px 5px;

  ${media.lessThan('small')`
    top: unset;
    bottom: 125px;
    left: 0;
    right: 0;
    border-radius: 0;
    box-shadow: none;
  `}
`
export const SearchButtonList = styled.div`
  display: flex;

  ${media.lessThan('small')`
    justify-content: space-around;
    margin-top: 1rem;
  `}
`
export const SearchButton = styled.button.attrs({ type: 'button' })`
  cursor: pointer;
  color: var(--color-primary);
  font-size: 1.125rem;
  padding: 14px;
  background-color: #fff;
  border: 0;
  border-left: 1px solid var(--color-fg-lighter);

  & svg {
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }

  ${media.lessThan('small')`
    background-color: transparent;
    border: 0;
    padding: 0;
    font-size: 1.25rem;
  `}
`
export const SearchButtonLabel = styled.div`
  display: none;
  font-size: 0.5rem;
  margin-top: 0.5rem;

  ${media.lessThan('small')`
    display: block;
  `}
`
export const SearchHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: var(--color-primary);
  padding: 10px 20px;
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #ebebeb;
  background-color: #ffffff;

  ${media.lessThan('small')`
    border-radius: 0;
    padding: 4px 16px;
  `}
`
export const SearchTitle = styled.h2`
  margin: 0;
  padding-left: 10px;
  flex-grow: 1;
  font-weight: var(--font-weight);

  ${media.lessThan('small')`
    font-size: 1.25rem;
  `}
`
export const DirectionWrapper = styled.div`
  width: 100%;
  border-radius: 0 0 5px 5px;
  padding: 20px;
  background: #ffffff;

  ${media.lessThan('small')`
    padding: 8px 16px;
  `}
`
export const DropdownWrapper = styled.div`
  display: flex;
`
export const DropdownItems = styled.div`
  flex: 1 1 auto;
  margin-right: 1rem;
`
export const ReverseWrapper = styled.div`
  flex: 0 0 1.5625rem;
  display: flex;
  align-items: center;
`
export const ReverseButton = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  font-size: 1.5rem;
  padding: 0;
  color: var(--color-primary);
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`
export const LocationsWrapper = styled.div`
  width: 100%;
  max-height: 400px;
  overflow: auto;
  border-radius: 0 0 5px 5px;
  background-color: #ffffff;

  ${media.lessThan('small')`
    border-radius: 0;
  `}
`
export const FoundNone = styled.div`
  padding: 2rem;
`
export const LocationsItemMain = styled.div`
  cursor: pointer;
  display: flex;
  padding: 20px;
  justify-content: space-between;
  border-top: 1px solid var(--color-fg-lighter);
  align-items: center;

  & span {
    color: var(--color-fg-light);
    white-space: nowrap;
  }
`
export const LocationLogo = styled.div.attrs(props => ({
  style: { backgroundImage: `url('${props.image}')` },
}))`
  flex: none;
  background: var(--color-fg-light);
  border-radius: 40px;
  height: 25px;
  width: 25px;
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 15px;
`
export const LocationName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  font-size: 0.7rem;
`
export const AccessibleButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  cursor: pointer;
  font-size: 25px;
  color: var(--color-primary);
  border-radius: 5px;
  border: 1px solid var(--color-primary);
  background-color: #fff;
  height: 3rem;
  padding: 0.5rem 1rem;
  opacity: 0.7;
  outline: none;

  &:hover {
    opacity: 1;
  }

  ${props =>
    props.accessible &&
    css`
      box-shadow: 0 0 0 1px var(--color-primary);
      opacity: 1;
    `}

  ${media.lessThan('small')`
    position: absolute;
    padding: 0.5rem;
    top: -60px;
    right: 1rem;
  `}

  transition: all var(--animation-duration) var(--animation-easing);
`
export const AccessibleIcon = styled.span`
  display: block;
  flex: 0 0 auto;
`
export const AccessibleIconDivider = styled.span`
  flex: 0 0 auto;
  display: block;
  height: 100%;
  border-left: 1px solid var(--color-primary);
  margin: 0 0.5rem;
`
export const IconButton = styled.button.attrs({ type: 'button' })`
  cursor: pointer;
  color: inherit;
  font-size: ${({ fontSize }) => fontSize || 'inherit'};
  padding: 0;
  background-color: transparent;
  border: 0;
`
export const StyledActionButton = styled(LinkButton)`
  position: absolute;
  z-index: 4;
  bottom: 0;
  right: 0;
  margin: 10px;

  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`
export const WithAddress = styled.div`
  position: relative;

  ${StyledDropdown} {
    select {
      height: 1.8rem;
      padding-top: 8px;
    }
  }
`
export const DropdownOptionLabel = styled.p`
  margin: 0;
  margin-top: 3px;
  line-height: 1rem;

  ${media.lessThan('small')`
    font-size: 0.75rem;
    font-weight: var(--font-weight-boldest);
  `}
`

export const DropdownOptionAddress = styled.p`
  margin: 0;
  font-size: 0.8rem;

  ${media.lessThan('small')`
    font-size: 0.5rem;
  `}
`

export const ErrorMessage = styled.output`
  display: block;
  color: var(--color-error);
  padding: 0 1rem;
  font-size: 0.75em;
  margin-bottom: 1rem;
  overflow: hidden;
  height: 1.125rem;
  transition-property: height, opacity;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);

  :empty {
    height: 0;
    opacity: 0;
  }
`

export const SurveyButtonContainer = styled.div`
  display: flex;
  align-items: end;
  gap: 16px;
`

export const SurveyButton = styled.button`
  background-color: #ee3625;
  border-radius: 6px;
  padding: 10px 16px;
  border: none;
  cursor: pointer;

  ${media.lessThan('small')`
    position: absolute;
    top: -50px;
    left: 0;
    margin-left: 10px;
  `}
`

export const SurveyButtonText = styled.span`
  color: #fff;
  font-size: 14px;
  font-weight: 600;
`

export const SurveyButtonContainerMobile = styled.div`
  display: none;

  ${media.lessThan('small')`
    display: flex;
  `}
`
